import user from "./user";
import session from "./session";
import subscription from "./subscription";
import social from "./social";
import prematch from "./prematch";
import ads from "./ads";
import match from "./match";

export default {
  ...user,
  ...session,
  ads,
  subscription,
  social,
  prematch,
  match,
  route: null,
};
